module.exports = __webpack_public_path__ + "img/RJC_LP_fertigung.6419284.jpg";